import React from 'react'
import MosaicInput from './MosaicInput'
import PropTypes from 'prop-types'

function Layout ({ state, onChange }) {
  return (
    <div>
      <MosaicInput
        inputTitle='Starting Horizontal Position'
        id='starting-horizontal-position'
        className='form-control'
        type='number'
        placeholder='0'
        value={state.initialHorizontalPosition}
        onChange={onChange('initialHorizontalPosition')}
      />
      <MosaicInput
        inputTitle='Starting Vertical Position'
        id='starting-vertical-position'
        className='form-control'
        type='number'
        placeholder='0'
        value={state.initialVerticalPosition}
        onChange={onChange('initialVerticalPosition')}
      />
      <MosaicInput
        inputTitle='Initial Zoom Level'
        id='initial-zoom-level'
        className='form-control'
        type='number'
        placeholder='0'
        value={state.initialZoomLevel}
        onChange={onChange('initialZoomLevel')}
      />
      <MosaicInput
        inputTitle='Zoom Fraction'
        id='zoom-fraction'
        className='form-control'
        type='number'
        placeholder='0'
        value={state.zoomFraction}
        onChange={onChange('zoomFraction')}
      />
      <MosaicInput
        inputTitle='Layers'
        id='layers'
        className='form-control'
        type='number'
        placeholder='0'
        value={state.layers}
        onChange={onChange('layers')}
      />
    </div>
  )
}

Layout.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default Layout



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-mosaic-deployment/components/Layout.js